import React from "react";
import { Link } from "react-router-dom";
import "../styles/OrderWithDelivery.css";

function OrderWithDelivery() {

    return (
        <div className="container-fluid order-with-delivery-section-background my-5-5 py-5">
            <div className="container">
                <div className="row">
                    <div className="col-12 col-md-6 order-with-delivery-content">
                        <h3 className="fs-2 text-green-light">Zamów z dowozem!</h3>
                        <hr className="divider py-0" />
                        <div className="order-with-delivery-text">
                            <p>Dania wydawane są również na wynos lub z opcją dostawy.
                            Za opakowania na wynos zostanie doliczone 2zł do każdej
                            pozycji w zamówieniu.
                            </p>
                            <p><span className="fw-bold">Darmowa dostawa</span> przy zamówieniu za min. 50zł na terenie Andrychowa.</p>
                            <p>Dostawa płatna wg. następującego harmonogramu:</p>
                            <div className="delivery-costs">
                                <p><span className="fw-bold">STREFA I</span> (Andrychów) - 3zł</p>
                                <p><span className="fw-bold">STREFA II</span> (poza terenem Andrychowa do 5km) - 6zł</p>
                                <p><span className="fw-bold">STREFA III</span> (poza terenem Andrychowa do 10km) - 12zł</p>
                                <p><span className="fw-bold">STREFA IV</span> (poza terenem Andrychowa do 15km) - 25zł</p>
                            </div>
                            <Link to={'/menu'} className="btn btn-primary">Zobacz menu</Link>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 order-with-delivery-photo-container">
                        <img src={require("../assets/photos/delivery.webp")} className="order-with-delivery-photo img-hover-zoom rounded img-shadow" />
                    </div>
                </div>
            </div>
        </div>
    )

}

export default OrderWithDelivery;